module.exports = require("react-infinite-scroll-component");